import React from 'react'
import axios from 'axios';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
import { useAppConfig } from '../../AppConfigProvider';
import logo from '../../images/Docusync-logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default function SignUp() {
    const appConfig = useAppConfig();

    const [fullname, setFullName] = useState();
    const [emali, setEmail] = useState();
    const [password, setPassword] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [agreed, setAgreed] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Keep only digits
        if (value.length <= 11) {
            setPhoneNo(value);
        } else {
            toast.warn("Mobile number cannot exceed 11 digits", {
                position: "top-right",
                autoClose: 2000,
                theme: "dark",
                toastId: "phone-limit"
            });
        }
    };

    const handleKeyDown = (e) => {
        // Allow: backspace, delete, tab, escape, enter, and .
        if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
             // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
             // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
                 // let it happen, don't do anything
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };
    const navigate = useNavigate();

    const handleSubmit = async e => {
        e.preventDefault();
        if (!agreed) {
            toast.error("Please agree to the Terms and Conditions", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }

        if (phoneNo && (phoneNo.length < 10 || phoneNo.length > 11)) {
            toast.error("Please enter a valid mobile number (10-11 digits)", {
                position: "top-right",
                autoClose: 2000,
                theme: "dark",
            });
            return;
        }
        const r_details = {
            "username": emali,
            "email": emali,
            "password": password,
            "fullname": fullname,
            "phoneNo": phoneNo,
            "companyName": companyName,
            "roles": ["qbpush"]
        }
        await registerUser(r_details);
    }

    async function registerUser(r_details) {
        return axios.post(`${appConfig.backendUrl}api/v1/auth/signup`, r_details)
            .then(function (response) {
                let message = response.data.message
                console.log("res", response.data);
                toast.success(`${message}`, {
                    position: "top-right",
                    autoClose: 1800,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                setTimeout(function () {
                    navigate('/login');
                }, 2000);
            })
            .catch((error) => {
                console.error(error);
                toast.error(`${error.response.data.message}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            });
    }

    return (<>
        <div className='login-page signup-page d-flex align-items-center justify-content-center min-vh-100'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-5 col-md-7 col-sm-9 col-11">
                        <div className="card shadow-lg border-0 rounded-4 my-2 my-md-4">
                            <div className="card-body p-4 p-md-4">
                                <div className="text-center mb-3">
                                    <img src={logo} alt="logo" className='logo-img img-fluid mb-2' style={{ maxWidth: '100px' }} />
                                    <h2 className="fw-bold fs-3" style={{ color: '#2c3e50' }}>Welcome!</h2>
                                    <p className="text-muted small">Please provide the following details <br className="d-none d-md-block" /> for your new account.</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <input type="text" className="form-control btn-radius btn-input py-2" id="fullname" placeholder="Full Name" onChange={e => setFullName(e.target.value)} />
                                    </div>
                                    <div className="mb-3">
                                        <input type="email" className="form-control btn-radius btn-input py-2" id="username" placeholder="Email Address" onChange={e => setEmail(e.target.value)} />
                                    </div>
                                    <div className="mb-3 position-relative">
                                        <div className="input-group btn-radius">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control btn-radius btn-input py-2 border-end-0"
                                                id="password"
                                                placeholder="Password"
                                                onChange={e => setPassword(e.target.value)}
                                            />
                                            <span className="input-group-text bg-transparent border-start-0 faEyeIcon" style={{ cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="text-muted" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="tel"
                                            className="form-control btn-radius btn-input py-2"
                                            id="phoneNo"
                                            placeholder="Phone Number (Optional)"
                                            value={phoneNo}
                                            onChange={handlePhoneChange}
                                            onKeyDown={handleKeyDown}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={11}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" className="form-control btn-radius btn-input py-2" id="companyName" placeholder="Company Name (Optional)" onChange={e => setCompanyName(e.target.value)} />
                                    </div>
                                    <div className="mb-3 text-muted" style={{ fontSize: '0.85rem' }}>
                                        <div className="d-flex align-items-center justify-content-center gap-2 text-start mx-auto" style={{ maxWidth: '300px' }}>
                                            <input type="checkbox" id="termsCheck" className="form-check-input mt-0" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} style={{ cursor: 'pointer' }} />
                                            <label htmlFor="termsCheck" className="mb-0" style={{ cursor: 'pointer', lineHeight: '1.4' }}>
                                                By creating an account you agree with our
                                                <button type="button" className='btn-link links ms-1' style={{ padding: 0, border: 'none', background: 'none', textDecoration: 'none', fontWeight: 'bold' }}>Terms and Conditions</button>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <button className='signin-btn w-100 py-2 shadow-sm fw-bold' style={{ transition: 'all 0.3s' }} type="submit">Sign Up</button>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <p className="mb-0 text-muted" style={{ fontSize: '0.95rem' }}>Already have an account? &nbsp;</p>
                                        <Link className='links text-decoration-none' to='/login'><b>Sign In</b></Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    </>
    )
}


